import { allocationConstants } from '../constants';

const initialState = {
    fetchingAllocations: false,
    allocations: [],
    fetchingAllocationsError: null,

    creatingAllocations: false,
    creatingAllocationsError: null,

    updatingAllocations: false,
    updatingAllocationsError: null,

    deletingAllocations: false,
    deletingAllocationsError: null,

    copyingAllocations: false,
    copyProgress: null,
};

export function allocations(state = initialState, action) {
    switch (action.type) {
        case allocationConstants.GET_ALLOCATION_REQUEST: {
            return {
                ...state,
                fetchingAllocations: true,
                fetchingAllocationsError: null,
            };
        }
        case allocationConstants.GET_ALLOCATION_SUCCESS: {
            return {
                ...state,
                fetchingAllocations: false,
                allocations: Array.isArray(action.allocations) ? action.allocations : [],
                fetchingAllocationsError: null,
            };
        }
        case allocationConstants.GET_ALLOCATION_FAILURE: {
            return {
                ...state,
                fetchingAllocations: false,
                fetchingAllocationsError: action.error,
            };
        }

        case allocationConstants.CREATE_ALLOCATION_REQUEST: 
            return { ...state, creatingAllocations: true, creatingAllocationsError: null };

        case allocationConstants.CREATE_ALLOCATION_SUCCESS: {
            const next = Array.isArray(state.allocations) ? state.allocations.slice() : [];
            next.push(action.allocation); // mapped allocation from server
            return { ...state, creatingAllocations: false, allocations: next, creatingAllocationsError: null };
        }
        
        case allocationConstants.CREATE_ALLOCATION_FAILURE: 
            return { ...state, creatingAllocations: false, creatingAllocationsError: action.error };

        case allocationConstants.UPDATE_ALLOCATION_REQUEST:
            return { ...state, updatingAllocations: true, updatingAllocationsError: null };

        case allocationConstants.UPDATE_ALLOCATION_SUCCESS: {
            const patch = action.allocation; 
            const list = Array.isArray(state.allocations) ? state.allocations : [];
            const getRowId = (x) => String(x?.allocation_id ?? x?.key ?? x?.id);
            const idx = list.findIndex((a) => getRowId(a) === getRowId(patch));

        if (idx === -1) {
            // If not found, append safely
            return {
            ...state,
            updatingAllocations: false,
            allocations: [...list, patch],
            updatingAllocationsError: null,
            };
        }

        const prev = list[idx];

        const merged = {
            ...prev,
            ...patch,
            // keep arrays if server omitted them
            scenarioId: Array.isArray(patch.scenarioId) ? patch.scenarioId : prev.scenarioId,
            targetScenarioId: Array.isArray(patch.targetScenarioId) ? patch.targetScenarioId : prev.targetScenarioId,
        };
        if (merged.key == null) merged.key = prev.key;

        const next = list.slice();
        next[idx] = merged;
        
        return { ...state, updatingAllocations: false, allocations: next, updatingAllocationsError: null };
    
        }

        case allocationConstants.UPDATE_ALLOCATION_FAILURE: {
            return {
                ...state,
                updatingAllocations: false,
                updatingAllocationsError: action.error,
            };
        }

        case allocationConstants.DELETE_ALLOCATION_REQUEST: {
            return {
                ...state,
                deletingAllocations: true,
                deletingAllocationsError: null,
            };
        }
        case allocationConstants.DELETE_ALLOCATION_SUCCESS: {
            const delId = String(action.payload?.id ?? action.id ?? action.allocation_id ?? action.key);
            const list = Array.isArray(state.allocations) ? state.allocations : [];
            const next = list.filter((a) => String(a?.allocation_id ?? a?.key ?? a?.id) !== delId);
            return { ...state, deletingAllocations: false, allocations: next, deletingAllocationsError: null };
            }
        
        case allocationConstants.DELETE_ALLOCATION_FAILURE: {
            return {
                ...state,
                deletingAllocations: false,
                deletingAllocationsError: action.error,
            };
        }

        case allocationConstants.COPY_ALLOCATIONS_REQUEST:
            return { ...state, copyingAllocations: true, copyProgress: { completed: 0, total: action.payload.total } };

        case allocationConstants.COPY_ALLOCATIONS_PROGRESS:
            return { ...state, copyProgress: action.payload };

        case allocationConstants.COPY_ALLOCATIONS_SUCCESS:
            return { ...state, copyingAllocations: false, copyProgress: null };

        default: {
            return state;
        }
    }
}
